<template>
	<transition>
		<div :class="activeClass" name="modal" v-show="show">
			<div class="modal-background"></div>

			<div class="modal-wrapper">
				<div class="modal-container">

					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" @click="$emit('cancel')">&times;</button>
						<h4><slot name="title">{{ _title }}</slot></h4>
					</div>
					<div class="modal-body">
						<slot></slot>
					</div>
					<div class="modal-footer" v-if="hasFooter">
						<span v-if="hasOK"    ><button data-dismiss="modal" @click="$emit('ok')"     v-bind:class="_okStyle"    >{{ _okText }}</button></span>
						<span v-if="hasCancel"><button data-dismiss="modal" @click="$emit('cancel')" v-bind:class="_cancelStyle">{{ _cancelText }}</button></span>
					</div>
				</div>
			</div>
		</div>
	</transition>

</template>

<script>
export default {
	props: {
		title: String,
		okText: String,
		cancelText: String,
		okStyle: String,
		cancelStyle: String
	},

	data () {
		return {
			show: false
		}
	},

	methods: {
		open (aCanCloseFunc) {
			this.show = true

			return new Promise((resolve, reject) => {
				this.$on("ok", () => {
					let canClose = true

					console.log("OK ECIEVED")

					if (typeof aCanCloseFunc === "function") {
						canClose = aCanCloseFunc()
					}

					if (canClose) {
						this.show = false
						resolve()
					}
				})

				this.$on("cancel", () => {
					console.log("CANCEL ECIEVED")

					this.show = false
					reject()
				})
			})
		},

		cancel () {
			this.$emit("cancel")
		},

		ok () {
			this.$emit("ok")
		}
	},

	computed: {
		_title () {
			return typeof this.title === 'undefined' ? null : this.title
		},

		_okText () {
			return typeof this.okText === 'undefined' ? null : this.okText
		},

		_cancelText () {
			return typeof this.cancelText === 'undefined' ? null : this.cancelText
		},

		_okStyle () {
			return typeof this.okStyle === 'undefined' ? 'btn btn-primary' : this.okStyle
		},

		_cancelStyle () {
			return typeof this.cancelStyle === 'undefined' ? 'btn btn-primary' : this.cancelStyle
		},

		hasOK () {
			return !(this._okText === null)
		},

		hasCancel () {
			return !(this._cancelText === null)
		},

		hasFooter () {
			return this.hasOK || this.hasCancel
		},

		activeClass () {
			return this.show ? "modal-mask" : "modal-mask-disabled"
		}
	}
}
</script>

<style>
.modal-mask-disabled {
	position: absolute;
	z-index: -9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: table;
	transition: opacity .3s ease;
}

.modal-mask {
	position: absolute;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: table;
	transition: opacity .3s ease;
}

.modal-background {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .5);
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	position: relative;
	z-index: 9999;
	width: 80%;
	max-height: 100%;
	margin: 0px auto;
	padding: 20px 30px;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
	transition: all .3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// custom-modal.vue?5bd9ffbc